import { configureStore } from "@reduxjs/toolkit";
import { tender360Api } from "./tender360Api";
import tender360ViewsReducer from "./tender360ViewsSlice";

export const tender360Store = configureStore({
  reducer: {
    [tender360Api.reducerPath]: tender360Api.reducer,
    tender360Views: tender360ViewsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(tender360Api.middleware),
});

